"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nonzero = exports.where = exports.take = void 0;
var NDArray_1 = require("../NDArray");
var basic_1 = require("../array/basic");
function take(a, indices, axis) {
    var where = a.shape.map(function () { return ':'; });
    where[axis] = indices;
    return a.index.apply(a, __spreadArray([], __read(where), false));
}
exports.take = take;
function where(condition, x, y, out) {
    if (out === void 0) { out = null; }
    if (typeof condition === 'boolean')
        return condition ? x : y;
    condition = (0, basic_1.asarray)(condition);
    if (out == null)
        out = condition.copy();
    else
        out = (0, basic_1.asarray)(out);
    out.assign(x, condition);
    out.assign(y, condition.logical_not());
    return out;
}
exports.where = where;
function nonzero(a) {
    var raw_indices = __spreadArray([], __read(a.flat), false).map(function (v, i) { return v ? i : null; }).filter(function (v) { return v !== null; });
    // Convert to many 1D arrays
    var indices = a.shape.map(function () { return new Int32Array(raw_indices.length); });
    raw_indices.forEach(function (v, pos) {
        for (var i = a.shape.length - 1; i >= 0; i--) {
            indices[i][pos] = v % a.shape[i];
            v = Math.floor(v / a.shape[i]);
        }
    });
    return indices.map(function (buffer) { return new NDArray_1.default(buffer); });
}
exports.nonzero = nonzero;
